export { createLanguageModelResponseMetadata as getResponseMetadata } from '@ai-sdk/provider-utils';
